    <div class="row centered">
        <div class="col-md-8 message">
            {{message()}}
            <button class="btn btn-action" (click)="clearMessage()">Ok</button>
        </div>
    </div>